var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.305,
    height: 18.29,
    viewBox: "0 0 14.305 18.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65265",
    "data-name": "Path 65265",
    d: "M.43,8.341H1.764V5.525a5.508,5.508,0,0,1,1.622-3.9h0a5.5,5.5,0,0,1,7.8,0h0a5.508,5.508,0,0,1,1.622,3.9V8.341h1.062a.432.432,0,0,1,.43.43V17.86a.432.432,0,0,1-.43.43H.43A.432.432,0,0,1,0,17.86V8.771a.432.432,0,0,1,.43-.43Zm3.48,0h6.756V5.494a3.371,3.371,0,0,0-.992-2.386h0A3.377,3.377,0,0,0,3.91,5.494V8.341Zm3.405,4.973L8,16.46l-1.869.008.548-3.189a1.268,1.268,0,1,1,.639.034Z",
    fill: "#707070",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePass);
export default __webpack_public_path__ + "static/media/change-pass.8ce8ff9c02d458ad89d0840c7efebb8a.svg";
export { ForwardRef as ReactComponent };